import React from "react";
import { useSelector } from "react-redux";
import LandingHeader from "../components/landing/LandingHeader";
import LandingFooter from "../components/landing/LandingFooter";

const TermsConditions = () => {
  const translation = useSelector((state) => state.translation);

  return (
    <div className="privacy-page">
      <LandingHeader />
      <main className="privacy-main">
        <div className="policy-hero-wrap">
          <div className="privacy-container">
            <div className="privacy-header">
              <h1>{translation.terms_title || "Terms & Conditions"}</h1>
              <p className="privacy-date">{translation.terms_effective_date || "Effective Date: January 21, 2026"}</p>
            </div>
          </div>
        </div>
        <div className="privacy-container content-area-container">

          <p className="privacy-intro">
            {translation.terms_intro_1 ||
              "Welcome to esyncing. These Terms & Conditions (\"Terms\") govern your access to and use of the esyncing platform, products, and services."}
          </p>
          <p className="privacy-intro">
            {translation.terms_intro_2 || "By using esyncing, you agree to be bound by these Terms."}
          </p>

          <section className="privacy-section">
            <h2>{translation.terms_section1_title || "1. Use of the Platform"}</h2>
            <p>{translation.terms_section1_text || "esyncing provides AI-powered tools including chat, virtual HR, knowledge management, integrations, and interactive demos."}</p>
            <p>{translation.terms_section1_subtitle || "You agree to:"}</p>
            <ul>
              <li>{translation.terms_section1_item1 || "Use the platform only for lawful purposes"}</li>
              <li>{translation.terms_section1_item2 || "Comply with all applicable laws and regulations"}</li>
              <li>{translation.terms_section1_item3 || "Not misuse, disrupt, or attempt unauthorized access to the platform"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section2_title || "2. Account Registration"}</h2>
            <p>{translation.terms_section2_text || "To access certain features, you may need to create an account."}</p>
            <p>{translation.terms_section2_subtitle || "You are responsible for:"}</p>
            <ul>
              <li>{translation.terms_section2_item1 || "Providing accurate and up-to-date information"}</li>
              <li>{translation.terms_section2_item2 || "Maintaining the confidentiality of your account credentials"}</li>
              <li>{translation.terms_section2_item3 || "All activities performed under your account"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section3_title || "3. User Content & Data"}</h2>
            <p>{translation.terms_section3_text || "You retain ownership of all content and data you upload or create in esyncing, including:"}</p>
            <ul>
              <li>{translation.terms_section3_item1 || "Chat messages"}</li>
              <li>{translation.terms_section3_item2 || "Documents and files"}</li>
              <li>{translation.terms_section3_item3 || "Knowledge base content"}</li>
              <li>{translation.terms_section3_item4 || "HR-related information"}</li>
            </ul>
            <p>{translation.terms_section3_footer || "By using the platform, you grant esyncing permission to process this content solely to provide and improve the service."}</p>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section4_title || "4. AI Features & Outputs"}</h2>
            <p>{translation.terms_section4_text || "esyncing uses AI to generate responses and automate workflows."}</p>
            <p>{translation.terms_section4_subtitle || "You acknowledge that:"}</p>
            <ul>
              <li>{translation.terms_section4_item1 || "AI outputs are generated based on provided data and configurations"}</li>
              <li>{translation.terms_section4_item2 || "AI responses may not always be accurate or complete"}</li>
              <li>{translation.terms_section4_item3 || "You are responsible for reviewing AI-generated outputs before relying on them"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section5_title || "5. Acceptable Use"}</h2>
            <p>{translation.terms_section5_text || "You agree NOT to:"}</p>
            <ul>
              <li>{translation.terms_section5_item1 || "Upload illegal, harmful, or abusive content"}</li>
              <li>{translation.terms_section5_item2 || "Violate privacy, security, or intellectual property laws"}</li>
              <li>{translation.terms_section5_item3 || "Reverse engineer, copy, or resell the platform"}</li>
              <li>{translation.terms_section5_item4 || "Use the platform for malicious or deceptive activities"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section6_title || "6. Integrations & Third-Party Services"}</h2>
            <p>{translation.terms_section6_text || "esyncing may integrate with third-party services."}</p>
            <ul>
              <li>{translation.terms_section6_item1 || "Use of third-party services is governed by their own terms and policies"}</li>
              <li>{translation.terms_section6_item2 || "esyncing is not responsible for third-party platforms"}</li>
              <li>{translation.terms_section6_item3 || "You control which integrations are enabled or disabled"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section7_title || "7. Subscriptions & Access"}</h2>
            <p>{translation.terms_section7_text || "Some features may require a paid subscription."}</p>
            <ul>
              <li>{translation.terms_section7_item1 || "Pricing and plans are published on the website"}</li>
              <li>{translation.terms_section7_item2 || "Failure to pay may result in limited access or suspension"}</li>
              <li>{translation.terms_section7_item3 || "esyncing may modify or discontinue features with reasonable notice"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section8_title || "8. Intellectual Property"}</h2>
            <p>{translation.terms_section8_text || "All platform content, design, and technology (excluding user content) are owned by esyncing."}</p>
            <p>{translation.terms_section8_footer || "You may not copy, distribute, or use eSyncing trademarks without permission."}</p>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section9_title || "9. Termination"}</h2>
            <p>{translation.terms_section9_text || "esyncing may suspend or terminate access if:"}</p>
            <ul>
              <li>{translation.terms_section9_item1 || "These Terms are violated"}</li>
              <li>{translation.terms_section9_item2 || "The platform is misused"}</li>
              <li>{translation.terms_section9_item3 || "Required by law"}</li>
            </ul>
            <p>{translation.terms_section9_footer || "You may stop using the platform at any time."}</p>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section10_title || "10. Limitation of Liability"}</h2>
            <p>{translation.terms_section10_text || "The platform is provided \"as is\"."}</p>
            <p>{translation.terms_section10_subtitle || "To the maximum extent permitted by law:"}</p>
            <ul>
              <li>{translation.terms_section10_item1 || "esyncing is not liable for indirect or consequential damages"}</li>
              <li>{translation.terms_section10_item2 || "esyncing is not responsible for business loss, data loss, or AI decision outcomes"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section11_title || "11. Changes to Terms"}</h2>
            <p>{translation.terms_section11_text || "We may update these Terms from time to time. Changes will be posted on this page with an updated effective date."}</p>
            <p>{translation.terms_section11_footer || "Continued use of the platform indicates acceptance of updated Terms."}</p>
          </section>

          <section className="privacy-section">
            <h2>{translation.terms_section12_title || "12. Contact Information"}</h2>
            <p>{translation.terms_section12_text || "For questions regarding these Terms:"}</p>
            <div className="privacy-contact">
              <div className="contact-card">
                <h4>{translation.terms_section12_card_title || "Email"}</h4>
                <p>{translation.terms_section12_card_email || "legal@esyncing.com"}</p>
                <span>{translation.terms_section12_card_note || "You can also reach our support team through the platform's contact page."}</span>
              </div>
            </div>
          </section>

          <p className="privacy-updated">
            {translation.terms_last_updated || "These Terms & Conditions were last updated on January 21, 2026."}
          </p>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
};

export default TermsConditions;
